// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"249":"129e90d1acb99a47","373":"3b9720a35213481f"}[chunkId] + ".js";
};